import { depictMerchant } from "@/lib/depict-client/depict-merchant"
import { type IOtherService } from "@/lib/depict-client/interfaces/IOtherService"
import { type GetDisplaysRequestV3 } from "@/lib/depict-client/types/api/GetDisplaysRequestV3"
import { type DisplayResponse } from "@/lib/depict-client/types/DisplayResponse"
import { type LocaleResponse } from "@/lib/depict-client/types/LocaleResponse"
import { type MarketResponse } from "@/lib/depict-client/types/MarketResponse"
import { type ClientFetchService } from "@/lib/http/ClientFetchService"
import { type FetchService } from "@/lib/http/FetchService"
import { type Result } from "@/types/generic/Result"

export class OtherApiService implements IOtherService {
    constructor(private fetchService: FetchService | ClientFetchService) {}

    /**
     * Returns a list of displays.
     * @param {GetDisplaysRequestV3} req
     * @link https://docs.depict.ai/reference/openapi-reference/other-v3/get-displays
     */
    public getDisplays = async (
        req: GetDisplaysRequestV3
    ): Promise<Result<DisplayResponse>> => {
        return this.fetchService.fetch("/get-displays", {
            method: "POST",
            body: JSON.stringify({ ...req, merchant: depictMerchant })
        })
    }

    /**
     * Returns a list of markets.
     * @param {string} merchant
     * @link https://docs.depict.ai/reference/openapi-reference/other-v3/get-markets
     */
    public getMarkets = async (): Promise<Result<MarketResponse>> => {
        return this.fetchService.fetch<MarketResponse>(
            `/markets?merchant=${depictMerchant}`,
            {
                method: "GET"
            }
        )
    }

    /**
     * Returns a list of locales.
     * @param {string} merchant
     * @link https://docs.depict.ai/reference/openapi-reference/other-v3/get-markets
     */
    public getLocales = async (): Promise<Result<LocaleResponse>> => {
        return this.fetchService.fetch(`/locales?merchant=${depictMerchant}`, {
            method: "GET"
        })
    }
}
